import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import { toAbsoluteUrl } from 'src/_metronic/helpers'

interface PasswordResetSuccessModalProps {
  show: boolean
  onClose: () => void
}

const PasswordResetSuccessModal: React.FC<PasswordResetSuccessModalProps> = ({
  show,
  onClose
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header className='border-0 pb-0'>
        <div className='w-100 text-center'>
       
          <Modal.Title className='d-block fs-5 fw-bold'>Password Reset</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className='px-5 py-4 text-center'>
         <div className='w-100 text-center'>
          <img 
         src={toAbsoluteUrl('/media/logos/def-small.png')}
            alt='logo' 
            className='mb-3'
            style={{height: '60px', width: 'auto'}}
          />
          </div>
        <p className='mb-4'>
          A password reset email has been sent to you. Kindly check your registered email.
        </p>
        <Button 
          className='btn-primary'
          onClick={onClose}
          style={{minWidth: '100px'}}
        >
          Ok
        </Button>
      </Modal.Body>
    </Modal>
  )
}

export {PasswordResetSuccessModal}
